import React, { useState, useEffect } from 'react';
import { IonText, IonIcon, IonSkeletonText } from '@ionic/react';
import { calendarOutline, locationOutline, peopleOutline, businessOutline } from 'ionicons/icons';
import { connect } from '../data/connect';
import './EventInfo.scss';

interface StateProps {
  eventcode?: string;
  username?: string;
  userother?: string;
  // Añadimos propiedades para almacenar la información del evento desde el login
  eventName?: string;
  eventStartDate?: string;
  eventEndDate?: string;
  eventLocation?: string;
}

interface EventInfoProps extends StateProps {}

const EventInfo: React.FC<EventInfoProps> = ({
  eventcode,
  username,
  userother,
  eventName,
  eventStartDate,
  eventEndDate,
  eventLocation
}) => {
  const [eventInfo, setEventInfo] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Extraer la información de la empresa y el rol del usuario
  const getUserInfo = () => {
    if (!userother) return { company: '', role: '' };

    const parts = userother.split('$$$');
    return {
      company: parts[0] || '',
      role: parts.length > 1 ? parts[1] : ''
    };
  };

  const { company, role } = getUserInfo();

  // Cargar la información del evento
  useEffect(() => {
    // Si tenemos la información del evento desde Redux, la usamos directamente
    if (eventName || eventStartDate || eventEndDate) {
      // Creamos un objeto con la información del evento
      const eventData = {
        texto2: eventName,
        texto3: eventStartDate,
        texto4: eventEndDate,
        texto6: eventLocation,
        eventCode: eventcode
      };

      setEventInfo(eventData);
      setLoading(false);
      setError(null);
      return;
    }

    // Si no tenemos la información del evento desde Redux, la obtenemos de la API
    const fetchEventInfo = async () => {
      if (!eventcode) {
        setLoading(false);
        setError('No hay un evento seleccionado');
        return;
      }

      setLoading(true);
      setError(null);

      try {
        // Intentar obtener información básica del evento
        const response = await fetch(`https://esimposio.com/miesimposio/appendpoints/${eventcode}/?type=info&uid=123456`);

        if (!response.ok) {
          throw new Error(`Error al obtener información del evento: ${response.status}`);
        }

        const data = await response.json();
        console.log('Información del evento:', data);
        setEventInfo(data);
      } catch (error) {
        console.error('Error al cargar la información del evento:', error);
        setError('No se pudo cargar la información del evento');
      } finally {
        setLoading(false);
      }
    };

    fetchEventInfo();
  }, [eventcode, eventName, eventStartDate, eventEndDate, eventLocation]);

  if (loading) {
    return (
      <div className="event-header">
        <div className="event-header-content">
          <div className="event-info">
            <IonSkeletonText animated style={{ width: '40%', height: '14px' }} />
            <IonSkeletonText animated style={{ width: '70%', height: '24px', marginTop: '8px' }} />
          </div>
          <div className="event-logo">
            <IonSkeletonText animated style={{ width: '70px', height: '70px', borderRadius: '50%' }} />
          </div>
        </div>
        <div className="event-details">
          <IonSkeletonText animated style={{ width: '90%', height: '16px', marginTop: '16px' }} />
          <IonSkeletonText animated style={{ width: '80%', height: '16px', marginTop: '8px' }} />
        </div>
      </div>
    );
  }

  if (error || !eventcode) {
    return null; // No mostrar nada si hay un error o no hay evento seleccionado
  }

  // Formatear la fecha para mostrarla de manera más amigable
  const formatDateRange = () => {
    // Usamos directamente las propiedades que recibimos de Redux
    const startDate = eventStartDate || (eventInfo && eventInfo.texto3) || '';
    const endDate = eventEndDate || (eventInfo && eventInfo.texto4) || '';

    if (!startDate) return 'Fecha no disponible';

    if (startDate === endDate) {
      return startDate;
    }

    return `${startDate} - ${endDate}`;
  };

  // Extraer el código de evento para mostrar como ID
  const getEventId = () => {
    return eventcode || '';
  };

  // Obtener el nombre del evento
  const getEventName = () => {
    return eventName || (eventInfo && eventInfo.texto2) || 'Evento Académico';
  };

  // Obtener la ubicación del evento
  const getEventLocation = () => {
    return eventLocation || (eventInfo && eventInfo.texto6) || 'Ubicación no disponible';
  };

  // Añadir información de depuración
  console.log('EventInfo Props:', {
    eventcode,
    username,
    userother,
    eventName,
    eventStartDate,
    eventEndDate,
    eventLocation
  });

  console.log('EventInfo Data:', eventInfo);

  return (
    <div className="event-header">
      <div className="event-header-content">
        <div className="event-info">
          {/*<IonText color="medium" className="event-id">
            ID: {getEventId()}
          </IonText>*/}
          <IonText>
            <h1 className="event-name">{getEventName()}</h1>
          </IonText>
        </div>
        <div className="event-logo">
          <div className="event-logo-circle">
            <IonIcon icon={calendarOutline} />
          </div>
        </div>
      </div>

      <div className="event-details">
        <div className="event-detail-item">
          <IonIcon icon={calendarOutline} />
          <IonText>{formatDateRange()}</IonText>
        </div>

        <div className="event-detail-item">
          <IonIcon icon={locationOutline} />
          <IonText>{getEventLocation()}</IonText>
        </div>
      </div>

      {/*<div className="event-user-info">
        <div className="event-user-item">
          <IonIcon icon={peopleOutline} />
          <IonText>{username || 'Usuario'}</IonText>
        </div>

        {(company || role) && (
          <div className="event-user-item">
            <IonIcon icon={businessOutline} />
            <IonText>{company}{company && role ? ' - ' : ''}{role}</IonText>
          </div>
        )}
      </div>*/}

      {/* Información de depuración */}
      <div style={{ display: 'none' }}>
        <p>eventName: {eventName}</p>
        <p>eventStartDate: {eventStartDate}</p>
        <p>eventEndDate: {eventEndDate}</p>
        <p>eventLocation: {eventLocation}</p>
        <p>eventInfo: {JSON.stringify(eventInfo)}</p>
      </div>
    </div>
  );
};

export default connect<{}, StateProps>({
  mapStateToProps: (state) => {
    // Extraemos la información del evento directamente desde el estado del usuario
    return {
      eventcode: state.user.eventcode,
      username: state.user.username,
      userother: state.user.userother,
      eventName: state.user.eventName,
      eventStartDate: state.user.eventStartDate,
      eventEndDate: state.user.eventEndDate,
      eventLocation: state.user.eventLocation
    };
  },
  component: EventInfo
});
